import primaryLogo from "../assets/BeLitFlameLogoPrimary.png"
import secondaryLogo from "../assets/BeLitFlameLogoSecondary.png"
import {ITheme} from "./types";
export const BeLit:ITheme = {
    name: "BeLit",
    colors: {
        offWhite: 'rgba(244, 244, 244, 1)',
        primaryGray: '#58595B',
        secondaryGray: '#9CA3AF',
        bgSecondary: '#9CA3AF',
        disabled: '#F2F5F7',
        darkPrimary: '#6F040D',
        primary: '#9B1521',
        primaryHover: '#B91C1C',
        primaryHalf: 'rgba(155,21,33,0.5)',
        secondary: 'rgba(111, 4, 13, 1)',
        "default-200": "#C6C6C6",
        "default-500": "#58595B",
        black: '#323232',
        success: '#2EB93A',
    },
    logos: {
        primary: primaryLogo,
        secondary: secondaryLogo,
        verticalNav: primaryLogo,
        favicon: primaryLogo
    }
    
}
